import { createContext, useContext } from "react";

const defaultBrand = window.__BRAND__ || {};

const BrandContext = createContext(defaultBrand);

/**
 * Access brand configuration (theme, branding, text).
 *
 * @returns {{ theme, branding, text, t: (key: string, vars?: object) => string }}
 */
export const useBrand = () => {
  const brand = useContext(BrandContext);

  /**
   * Get a text value by dot-notation key with optional variable interpolation.
   * Falls back to the key itself if not found.
   *
   * @example t("scheduling.thankYouMessage", { date: "March 25" })
   * // => "Thank you for your support, your pickup is confirmed for March 25."
   */
  const t = (key, vars = {}) => {
    const parts = key.split(".");
    let value = brand.text;
    for (const part of parts) {
      if (value === undefined || value === null) return key;
      value = value[part];
    }
    if (typeof value !== "string") return key;

    // Interpolate {varName} placeholders
    return value.replace(/\{(\w+)\}/g, (_, name) => vars[name] ?? `{${name}}`);
  };

  return {
    theme: brand.theme || {},
    branding: brand.branding || {},
    text: brand.text || {},
    t,
  };
};

export const BrandProvider = ({ children }) => (
  <BrandContext.Provider value={defaultBrand}>{children}</BrandContext.Provider>
);

export default BrandContext;
